export interface SourceDiagnostic {
	line: number;
	column: number;
	severity: 'error' | 'warning' | 'info';
	message: string;
}

export function parseDiagnostics(output: string): SourceDiagnostic[] {
	const diagnostics: SourceDiagnostic[] = [];
	for (const line of output.split('\n')) {
		const match = line.match(
			/^(?:.*\/)?main\.c:(\d+):(\d+): (fatal error|error|warning|note): (.*)$/,
		);
		if (!match) continue;
		diagnostics.push({
			line: Number(match[1]),
			column: Number(match[2]),
			severity: match[3] === 'note' ? 'info' : match[3] === 'warning' ? 'warning' : 'error',
			message: match[4],
		});
	}
	return diagnostics;
}
